import React from "react";

import { Divider } from "@mui/material";

import { Theme } from "../../../Style/Theme";
import { SubHeader } from "../../atoms/Typography/SubHeader/SubHeader";
import { FormItemsWrap } from "../Wrap/Wrap";

export const InformationBox = ({ title, children, width }) => {
  return (
    <div
      style={{
        backgroundColor: Theme.palette.blue.light,
        border: `1px solid `,
        borderRadius: "7px",
        borderColor: Theme.palette.blue.light2,
        padding: "10px 11px",
        width: width,
      }}
    >
      <SubHeader text={title} color={Theme.palette.black} />
      <Divider
        style={{
          color: Theme.palette.blue.light2,
          margin: "10px 0",
          backgroundColor: Theme.palette.blue.light2,
          height: "0.5px",
        }}
      />
      <FormItemsWrap gap={"8px"}>{children}</FormItemsWrap>
    </div>
  );
};
